teste
<template>
    <div class="row">
        <div class="col-md-12">
            <nav class="navbar navbar-default">
              <div class="container-fluid">
                <loading v-if="! showContent"></loading>
                <div class="navbar-header">
                  <button
                          type="button"
                          class="navbar-toggle collapsed"
                          data-toggle="collapse"
                          data-target="#navbar"
                          aria-expanded="false"
                          aria-controls="navbar"
                          ref="toggle">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                  </button>
                </div>

                <div id="navbar" class="navbar-collapse collapse" aria-expanded="false" style="height: 1px;">
                  <ul class="nav navbar-nav">

                    <li v-for="item in items" :class="currentRoute === item.url ? 'active' : ''">
                      <router-link v-on:click.native="clickMenu" :to="getUrl(item)">{{ item.name }}</router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
        </div>
    </div>
</template>

<script type="text/javascript">
  import {get} from '../../helpers/api';
  import Loading from '../common/Loading.vue';

  export default {
    components: {
      Loading
    },
    props: ['bloco'],
    data() {
      return {
        items: [],
        currentRoute: '',
        showContent: true
      }
    },
    created() {
      this.currentRoute = this.$route.name;

      let self = this;
      get('content/' + this.bloco.id).then(function (response) {
        self.items = response.data.result.data;
        self.showContent = true;
      });
    },
    methods: {
      getUrl(item) {
        if (item.default === 0) {
          return '/' + item.url;
        } else {
          return '/internas/' + item.url;
        }
      },
      clickMenu() {
        if (!$(this.$refs.toggle).hasClass('collapsed')) {
          $(this.$refs.toggle).click();
        }
      }
    },
    computed: {
      checkItems() {
        return this.items.length > 0;
      }
    },
    watch: {
      $route(to) {
        if (typeof to.params.page !== 'undefined') {
          this.currentRoute = to.params.page;
        } else {
          this.currentRoute = to.name;
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/home/Menu.vue